import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Icon from "components/Library/Icon";

import styles from "./SocialLink.css";

export default function SocialLink({ href, name, description, className }) {
  return (
    <a
      rel="noopener"
      target="_blank"
      href={href}
      className={classNames(styles.mobileSocialLink, className)}
      aria-label={description}
    >
      <Icon name={name} className={classNames(styles.icon, styles.noPointer)} />
    </a>
  );
}

SocialLink.propTypes = {
  href: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  className: PropTypes.string,
};
